import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'
import { Select } from '@center/ui-kit'
import { 
  DropdownIndicator, 
  ValueContainer, 
  CustomOption, 
  CustomControl, 
  getSelectStyles 
} from 'components/global/Selects/SingleSelectStyles'

export enum DateRange {
  Today = 'today',
  Yesterday = 'yesterday',
  Week = 'week',
  Month = 'month'
}

export interface DateRangeSelectChoice {
  label: string
  value: DateRange
  id: number
}

interface DateRangeSelectProps {
  value: DateRange
  onChange: (value: DateRangeSelectChoice) => void
}

const DateRangeSelect = ({ value, onChange }: DateRangeSelectProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const choices = [
    {
      label: t('stats.range_select.today'),
      value: DateRange.Today,
      id: 1
    },
    {
      label: t('stats.range_select.yesterday'),
      value: DateRange.Yesterday,
      id: 2
    },
    {
      label: t('stats.range_select.week'),
      value: DateRange.Week,
      id: 3
    },
    {
      label: t('stats.range_select.month'),
      value: DateRange.Month,
      id: 4
    }
  ]
  
  return (
    <Select
      value={choices.find((choice) => choice.value === value)}
      onChange={onChange}
      options={choices}
      mainField={'label'}
      components={{
        Option: CustomOption,
        DropdownIndicator,
        ValueContainer,
        Control: CustomControl,
        IndicatorSeparator: () => null,
        ClearIndicator: () => null
      }}
      menuPortalTarget={document.body}
      styles={getSelectStyles(theme)}
    />
  )
}

export default DateRangeSelect
